let nextPanelId = 0;

/**
 * A DOM id for a page's results region that is unique per component INSTANCE.
 *
 * Five RA pages point an `agu-tab-strip` at their results panel through
 * `aria-controls`, and they used to do it with a literal (`ra-saved-results`,
 * `ra-search-results`, `ra-grants-results`, …). MJExplorer's shell can hold two
 * Research Accelerator tabs at once — `AGURenderService`'s own header says so,
 * and it is why `ResearchApiService`/`MemberItemStateService` are provided by
 * `RaSurfaceComponent` rather than at the root — in which case those ids
 * duplicate and every tab's `aria-controls` resolves to whichever panel the
 * document happens to hold first. Review M-9; the same device
 * `AGUFilterRailComponent` already uses for its `aria-labelledby` head id.
 *
 * @param slug the page's own name, kept in the id so it stays readable in the
 *             inspector and in a regression-suite probe (`ra-saved-results-3`).
 */
export function NextResultsPanelId(slug: string): string {
    nextPanelId += 1;
    return `ra-${slug}-results-${nextPanelId}`;
}
